export default "__VITE_ASSET__f8xQrp5e__"